<template>
<div :class="bem('third-parties')">
    <!-- <div :class="bem('third-parties-title')" /> -->
    <div :class="bem('third-parties-content')">
        <div :class="bem('icon-wrap')" @click="vm.launchQQAuthorizationFlow()" v-if="isIncludesWay('qq')">
            <Icon :class="bem('right-icon')" name="gdd-qq" />
            QQ登录
        </div>
        <div :class="bem('icon-wrap')" @click="vm.launchQiyeWechatAuthorizationFlow()" v-if="isIncludesWay('qiyeWechat')">
            <img :class="bem('icon-wrap-img')" src="https://cdn.dancf.com/fe-assets/20220328/44b65c243f00c6a243b74812a99a2239.svg" alt="">
            企业微信登录
        </div>
        <!-- <div :class="bem('icon-wrap')" @click="vm.switchType('wechat')" v-if="isWechatWay && isIncludesWay('wechat')">
            <Icon :class="bem('right-icon')" name="gdd-wechat" />
            微信登录
        </div> -->
        <!-- <div :class="bem('icon-wrap')" @click="vm.switchType('phone')" v-else-if="!isWechatWay && isIncludesWay('phone')">
            <Icon :class="bem('right-icon')" name="gdd-phone" />
            手机号登录
        </div> -->
        <div :class="bem('icon-wrap', 'inline')"  @click="vm.switchType('register')" v-if="isIncludesWay('register')">
            <img :class="bem('icon-wrap-img')" src="https://cdn.dancf.com/fe-assets/20220411/025dfbe432dc89130c7ca63ebd3184da.svg" alt="">
            手机号注册
        </div>
    </div>
</div>

</template>
<script>
import _Icon from "@gaoding/gdui/lib/icon";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bemMixin from './bem';
export default {
  name: 'g-auth-other-way-login',
  inject: ['vm'],
  components: {
    Icon: _Icon
  },
  mixins: [bemMixin],
  props: {
    type: {
      type: String,
      default: 'phone' // wechat: 展示微信登录 icon   phone: 展示手机登录 icon

    }
  },
  computed: {
    isWechatWay: function isWechatWay() {
      return this.type === 'wechat';
    }
  },
  methods: {
    isIncludesWay: function isIncludesWay(type) {
      return this.vm.loginWays.includes(type);
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-other-way-login__third-parties {
  position: absolute;
  bottom: 82px;
  left: 0;
  height: 22px;
  width: 100%;
  padding: 0 24px;
}
.g-auth-other-way-login__third-parties-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.g-auth-other-way-login__third-parties-title {
  display: flex;
  align-items: center;
  height: 0;
  border-top: 1px dashed #E8EAEC;
}
.g-auth-other-way-login__third-parties-text {
  padding: 0 16px;
  line-height: 12px;
  font-size: 12px;
  color: #8D949E;
}
.g-auth-other-way-login__icon-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 133px;
  font-size: 14px;
  color: #33383E;
  padding: 0 20px;
  height: 16px;
  line-height: 22px;
  font-weight: 500;
  font-style: normal;
  cursor: pointer;
  white-space: nowrap;
}
.g-auth-other-way-login__icon-wrap--inline {
  display: flex;
  flex-direction: row;
  border-right: none;
}
.g-auth-other-way-login__icon-wrap:hover {
  color: #2254F4;
}
.g-auth-other-way-login__icon-wrap-img {
  display: block;
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.g-auth-other-way-login__icon-wrap:not(:last-child) {
  border-right: 1px solid #E8EAEC;
}
.g-auth-other-way-login__right-icon {
  width: 16px !important;
  height: 16px !important;
  margin-right: 5px;
}

</style>
